import Instance from "../../../Axios";

const GetTipoPropostas = () => async (dispatch) => {
  await Instance()
    .get(`/intervencoes/intervencoes/tipoPropostas/tipoPropostas`)
    .then(({ data }) => {
      dispatch({ type: "GET_TIPO_PROPOSTAS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTipoPropostas;
